import ExamListItem from "./exam-list-item"
import { ModuleHeader, Hr } from '../../styles/dashboard'


const ExamList = () => {
    return (
        <div>
            <ModuleHeader>
                <span>Exam list</span>
                <Hr />
            </ModuleHeader>
            <ExamListItem />
            <ExamListItem />
            <ExamListItem />
        </div>
    )
}

export { ExamList }
